import { StatusVariant } from '@consigli/types';
import clsx from 'clsx';
import { HiCheck, HiX, HiExclamation, HiInformationCircle } from 'react-icons/hi';
interface AlertProps {
  variant: StatusVariant;
  title: string;
  description: string;
  className?: string;
}

export const Alert = ({ variant, title, description, className }: AlertProps) => {
  return (
    <div
      className={clsx('p-4 rounded-md border', className, {
        'bg-green-500/10 border-green-500 text-green-800': variant === StatusVariant.SUCCESS,
        'bg-red-500/10 border-red-500 text-red-800': variant === StatusVariant.ERROR,
        'bg-yellow-500/10 border-yellow-500 text-yellow-800': variant === StatusVariant.WARNING,
        'bg-blue-500/10 border-blue-500 text-blue-800': variant === StatusVariant.INFO,
      })}
    >
      <div className="flex items-start gap-2">
        {variant === StatusVariant.SUCCESS && (
          <HiCheck className="h-5 w-5 flex-shrink-0 text-green-800" />
        )}
        {variant === StatusVariant.ERROR && <HiX className="h-5 w-5 flex-shrink-0 text-red-800" />}
        {variant === StatusVariant.WARNING && (
          <HiExclamation className="h-5 w-5 flex-shrink-0 text-yellow-800" />
        )}
        {variant === StatusVariant.INFO && (
          <HiInformationCircle className="h-5 w-5 flex-shrink-0 text-blue-800" />
        )}
        <div className="flex flex-col gap-1">
          <h2 className="text-sm font-medium">{title}</h2>
          <p className="text-xs">{description}</p>
        </div>
      </div>
    </div>
  );
};
